import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBXeC5hPA2sll-49Px4YizN3tvoAYIDgLo",
  authDomain: "taperlabs-shadow.firebaseapp.com",
  projectId: "taperlabs-shadow",
  storageBucket: "taperlabs-shadow.firebasestorage.app",
  messagingSenderId: "1080608993297",
  appId: "1:1080608993297:web:1a52fead65f3d5f61d01b0",
  measurementId: "G-KR2SJL0E57",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
